'use strict';

import { Init } from '@src/ts/Init.js';

new Init(); // NOSONAR